const GRAPHQL_PATH_SUFFIX_REGEX = /\/?graphql\/?$/;

export const getUsersPasswordEndpoint = () => {
  const graphqlUrl = import.meta.env.VITE_API_URL as string | undefined;

  if (!graphqlUrl) {
    return '/users/password';
  }

  try {
    const url = new URL(graphqlUrl);
    const basePath = url.pathname.replace(GRAPHQL_PATH_SUFFIX_REGEX, '');
    url.pathname = `${basePath}/users/password`.replace(/\/+/g, '/');
    url.search = '';
    url.hash = '';
    return url.toString();
  } catch {
    const normalizedBaseUrl = graphqlUrl.replace(GRAPHQL_PATH_SUFFIX_REGEX, '');
    return `${normalizedBaseUrl}/users/password`;
  }
};
